import React, {Component} from 'react';
import {useDeviceLayout} from "./common/context/DeviceLayoutContext";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getNodeId} from "../Utility";
import Column from "@amzn/meridian/column";
import {getGridAllocationDataForNode} from "../actions/GridAllocationActions";
import Row from "@amzn/meridian/row";
import {
    unFlattenSortLocationsModel,
    compareAisleInfoForSorting,
    getTableStyle
} from "./utils/GridAllocationUtil";
import AisleInfo from "./gridAllocation/AisleInfo";
import Loader from "@amzn/meridian/loader";
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import SortLocationInfo from "./gridAllocation/SortLocationInfo";

/**
 * Component to render the grid allocation view
 */
class GridAllocation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            modalAisleInfo: {}
        };
    }

    componentDidMount() {
        // load the grid allocation data
        this.props.dispatch(getGridAllocationDataForNode(getNodeId()));
    }

    renderAisleAllocationData() {
        const {gridAllocationData} = this.props;
        const clusterInfoMap = unFlattenSortLocationsModel(gridAllocationData.sortLocations);

        return (
            <Row width="100%" widths="fill">
                {
                    Object.keys(clusterInfoMap).sort().map((clusterLabel,i)=>{
                        const aisleInfoMap = clusterInfoMap[clusterLabel].aisleInfoMap;
                        return (
                            <Column key={i}>
                                <table key={"1"} style={getTableStyle("none")}>
                                    <tbody key={"1"}>
                                    {
                                        Object.values(aisleInfoMap).sort(compareAisleInfoForSorting)
                                            .map((aisleInfo,i) => {
                                                return <AisleInfo key={i} aisleInfo={aisleInfo}
                                                                  onClickAisleInfo={this.onClickAisleInfo} />
                                            })
                                    }
                                    </tbody>
                                </table>
                            </Column>
                        )
                    })
                }
            </Row>
        );
    }

    renderLoader() {
        return (
            <Column height="400px"  alignmentHorizontal="center">
                <Loader/>
            </Column>
        );
    }

    renderErrorToast() {
        return (
            <Alert toast={true} size="medium" type="error">
                <FormattedMessage id="stow.error" defaultMessage="Some Error Occured"/>
            </Alert>
        );
    }

    renderModalForViewSortLocations() {
        return (
            <Modal open={this.state.isModalOpen}
                   scrollContainer="modal"
                   describedById="sort-locations-modal">
                    <h3><FormattedMessage id="aisle.aisle" defaultMessage="Aisle"/> {this.state.modalAisleInfo ? this.state.modalAisleInfo.label : ""}</h3>
                    <Row>
                        { this.state.modalAisleInfo.sortLocations ?
                            Object.keys(this.state.modalAisleInfo.sortLocations).sort().map((columnLabel,i)=>{
                                const sortLocations = this.state.modalAisleInfo.sortLocations[columnLabel];
                                return (
                                    <Column key="1">
                                        <table key={"1"} style={getTableStyle("none")}>
                                            <tbody key={"1"}>
                                            {
                                                sortLocations.sort()
                                                    .map((sortLocation, i) => {
                                                        return <SortLocationInfo key={i} sortLocationInfo={sortLocation}/>
                                                    })
                                            }
                                            </tbody>
                                        </table>
                                    </Column>
                                )
                            }) : ""
                        }
                    </Row>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="primary" size="small" onClick={this.onClickCloseButton}>
                            <FormattedMessage id="stow.close" defaultMessage="Close"/>
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        );
    }

    onClickCloseButton = () => {
        this.setState({
            isModalOpen: false
        })
    };

    onClickAisleInfo = (aisleInfo) => {
        this.setState({
            isModalOpen: true,
            modalAisleInfo: aisleInfo
        })
    };

    render() {
        const {loading, isError} = this.props;
        return (
            <div>
                {isError ? this.renderErrorToast() : null}
                {loading ? this.renderLoader() : this.renderAisleAllocationData() }
                {this.renderModalForViewSortLocations()}
            </div>
        );
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {spacingInset_shorthand4} = useDeviceLayout();
        return <CustomComponent {...props} spacingInset_shorthand4={spacingInset_shorthand4}/>
    }
}

const mapStateToProps = state => ({
    loading: state.gridAllocationReducer.loading,
    gridAllocationData: state.gridAllocationReducer.gridAllocationData,
    isError: state.gridAllocationReducer.isError
});
export default withRouter(connect(mapStateToProps)(classToFunctionAdapter(GridAllocation)));


// WEBPACK FOOTER //
// ./src/components/GridAllocation.js